"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  CATEGORY_3D_MOVEMENT: () => CATEGORY_3D_MOVEMENT,
  CATEGORY_3D_PRINTING: () => CATEGORY_3D_PRINTING,
  CATEGORY_BALL_BEARINGS: () => CATEGORY_BALL_BEARINGS,
  CATEGORY_BAR_STOCKS: () => CATEGORY_BAR_STOCKS,
  CATEGORY_CABLES_FOR_MOTION: () => CATEGORY_CABLES_FOR_MOTION,
  CATEGORY_CF: () => CATEGORY_CF,
  CATEGORY_COATINGS: () => CATEGORY_COATINGS,
  CATEGORY_CONNECTING_CABLES: () => CATEGORY_CONNECTING_CABLES,
  CATEGORY_CONNECTORS: () => CATEGORY_CONNECTORS,
  CATEGORY_DRIVE_TECHNOLOGY_FOR_LINEAR_MOVEMENTS: () => CATEGORY_DRIVE_TECHNOLOGY_FOR_LINEAR_MOVEMENTS,
  CATEGORY_DRYGEAR_GEAR_TECHNOLOGY: () => CATEGORY_DRYGEAR_GEAR_TECHNOLOGY,
  CATEGORY_DRYLIN_LEAD_SCREW_TECHNOLOGY: () => CATEGORY_DRYLIN_LEAD_SCREW_TECHNOLOGY,
  CATEGORY_DRYLIN_LINEAR_TECHNOLOGY: () => CATEGORY_DRYLIN_LINEAR_TECHNOLOGY,
  CATEGORY_DRYLIN_Q_LINEAR_SQUARE_GUIDES: () => CATEGORY_DRYLIN_Q_LINEAR_SQUARE_GUIDES,
  CATEGORY_DRYLIN_R_SHAFT_GUIDES: () => CATEGORY_DRYLIN_R_SHAFT_GUIDES,
  CATEGORY_DRYLIN_T_RAIL_GUIDE: () => CATEGORY_DRYLIN_T_RAIL_GUIDE,
  CATEGORY_E_CHAIN: () => CATEGORY_E_CHAIN,
  CATEGORY_E_CHAIN_HORIZONTAL_SHELVES: () => CATEGORY_E_CHAIN_HORIZONTAL_SHELVES,
  CATEGORY_E_CHAIN_INTERIOR_SEPARATORS: () => CATEGORY_E_CHAIN_INTERIOR_SEPARATORS,
  CATEGORY_E_CHAIN_LINEAR_MOVEMENT: () => CATEGORY_E_CHAIN_LINEAR_MOVEMENT,
  CATEGORY_E_CHAIN_MOUNTING_BRACKETS: () => CATEGORY_E_CHAIN_MOUNTING_BRACKETS,
  CATEGORY_E_CHAIN_SMART_IOT_SOLUTIONS: () => CATEGORY_E_CHAIN_SMART_IOT_SOLUTIONS,
  CATEGORY_E_CHAIN_STRAIN_RELIEFS: () => CATEGORY_E_CHAIN_STRAIN_RELIEFS,
  CATEGORY_GEARS_GEAR_RACKS: () => CATEGORY_GEARS_GEAR_RACKS,
  CATEGORY_HARNESSED_CABLES: () => CATEGORY_HARNESSED_CABLES,
  CATEGORY_IGUBAL_SELF_ALIGNING_BEARINGS: () => CATEGORY_IGUBAL_SELF_ALIGNING_BEARINGS,
  CATEGORY_LINER: () => CATEGORY_LINER,
  CATEGORY_LOW_COST_AUTOMATION: () => CATEGORY_LOW_COST_AUTOMATION,
  CATEGORY_MOTORS: () => CATEGORY_MOTORS,
  CATEGORY_MOTOR_FLANGES: () => CATEGORY_MOTOR_FLANGES,
  CATEGORY_PMA: () => CATEGORY_PMA,
  CATEGORY_PNEUMATIC_HOSES: () => CATEGORY_PNEUMATIC_HOSES,
  CATEGORY_ROLLERS: () => CATEGORY_ROLLERS,
  CATEGORY_SLEWING_RINGS_AND_SLEWING_RING_BEARINGS: () => CATEGORY_SLEWING_RINGS_AND_SLEWING_RING_BEARINGS,
  isCategoryEnabled: () => isCategoryEnabled
});
module.exports = __toCommonJS(src_exports);

// src/categories.helper.ts
var CATEGORY_CF = "CF";
var CATEGORY_ROLLERS = "rollers";
var CATEGORY_HARNESSED_CABLES = "harnessed_cables";
var CATEGORY_PNEUMATIC_HOSES = "pneumatic_hoses";
var CATEGORY_CABLES_FOR_MOTION = "cables_for_motion";
var CATEGORY_SLEWING_RINGS_AND_SLEWING_RING_BEARINGS = "slewing_rings_and_slewing_ring_bearings";
var CATEGORY_GEARS_GEAR_RACKS = "gears_gear_racks";
var CATEGORY_E_CHAIN = "e_chains";
var CATEGORY_E_CHAIN_INTERIOR_SEPARATORS = "interior_separators";
var CATEGORY_E_CHAIN_MOUNTING_BRACKETS = "mounting_brackets";
var CATEGORY_E_CHAIN_HORIZONTAL_SHELVES = "horizontal_shelves";
var CATEGORY_E_CHAIN_LINEAR_MOVEMENT = "linear_movement";
var CATEGORY_E_CHAIN_STRAIN_RELIEFS = "strain_reliefs";
var CATEGORY_E_CHAIN_SMART_IOT_SOLUTIONS = "smart_iot_solutions";
var CATEGORY_DRYGEAR_GEAR_TECHNOLOGY = "gear_technology";
var CATEGORY_IGUBAL_SELF_ALIGNING_BEARINGS = "self_aligning_bearings";
var CATEGORY_DRYLIN_LEAD_SCREW_TECHNOLOGY = "drylin_lead_screw_technology";
var CATEGORY_DRYLIN_LINEAR_TECHNOLOGY = "drylin_linear_technology";
var CATEGORY_DRYLIN_T_RAIL_GUIDE = "t_rail_guide";
var CATEGORY_DRYLIN_R_SHAFT_GUIDES = "r_shaft_guides";
var CATEGORY_DRYLIN_Q_LINEAR_SQUARE_GUIDES = "q_linear_square_guide";
var CATEGORY_MOTOR_FLANGES = "motor_flanges";
var CATEGORY_CONNECTING_CABLES = "connecting_cables";
var CATEGORY_MOTORS = "motors";
var CATEGORY_DRIVE_TECHNOLOGY_FOR_LINEAR_MOVEMENTS = "drive_technology_for_linear_movements";
var CATEGORY_BALL_BEARINGS = "ball_bearings";
var CATEGORY_COATINGS = "coatings";
var CATEGORY_LINER = "liner";
var CATEGORY_3D_PRINTING = "3D_printing_materials";
var CATEGORY_3D_MOVEMENT = "3D_movement";
var CATEGORY_BAR_STOCKS = "bar_stocks";
var CATEGORY_LOW_COST_AUTOMATION = "low_cost_automation";
var CATEGORY_CONNECTORS = "connectors";
var CATEGORY_PMA = "PMA_protective_hoses_and_accessories";
var isCategoryEnabled = /* @__PURE__ */ __name((categoryKeys, featureFlags, defaultValue = false) => {
  if (categoryKeys.includes(CATEGORY_ROLLERS)) {
    return !!featureFlags.get("showRollers");
  }
  if (categoryKeys.includes(CATEGORY_LOW_COST_AUTOMATION)) {
    return !!featureFlags.get("showLowCostAutomation");
  }
  if (categoryKeys.includes(CATEGORY_E_CHAIN_SMART_IOT_SOLUTIONS)) {
    return !!featureFlags.get("showEchainSmartIotSolutions");
  }
  if (categoryKeys.includes(CATEGORY_E_CHAIN_STRAIN_RELIEFS)) {
    return !!featureFlags.get("showEChainStrainReliefs");
  }
  if (categoryKeys.includes(CATEGORY_E_CHAIN_INTERIOR_SEPARATORS)) {
    return !!featureFlags.get("showEChainInteriorSeparators");
  }
  if (categoryKeys.includes(CATEGORY_E_CHAIN_HORIZONTAL_SHELVES)) {
    return !!featureFlags.get("showEChainHorizontalShelves");
  }
  if (categoryKeys.includes(CATEGORY_E_CHAIN_MOUNTING_BRACKETS)) {
    return !!featureFlags.get("showEChainMountingBrackets");
  }
  if (categoryKeys.includes(CATEGORY_3D_MOVEMENT)) {
    return !!featureFlags.get("show3dMovement");
  }
  if (categoryKeys.includes(CATEGORY_E_CHAIN_LINEAR_MOVEMENT)) {
    return !!featureFlags.get("showEchainLinearMovement");
  }
  if (categoryKeys.includes(CATEGORY_E_CHAIN)) {
    return !!featureFlags.get("showEChain") && !featureFlags.get("showEChainSelectedModelsOnly");
  }
  if (categoryKeys.includes(CATEGORY_MOTOR_FLANGES)) {
    return !!featureFlags.get("showMotorFlanges");
  }
  if (categoryKeys.includes(CATEGORY_3D_PRINTING)) {
    return !!featureFlags.get("show3dPrinting");
  }
  if (categoryKeys.includes(CATEGORY_CONNECTING_CABLES)) {
    return !!featureFlags.get("showConnectingCables");
  }
  if (categoryKeys.includes(CATEGORY_MOTORS)) {
    return !!featureFlags.get("showMotors");
  }
  if (categoryKeys.includes(CATEGORY_DRIVE_TECHNOLOGY_FOR_LINEAR_MOVEMENTS)) {
    return !!featureFlags.get("showDriveTechnology");
  }
  if (categoryKeys.includes(CATEGORY_DRYLIN_LEAD_SCREW_TECHNOLOGY)) {
    return !!featureFlags.get("showDrylinLeadScrews");
  }
  if (categoryKeys.includes(CATEGORY_LINER)) {
    return !!featureFlags.get("showTribotape");
  }
  if (categoryKeys.some((ck) => ck && [
    CATEGORY_CF,
    CATEGORY_HARNESSED_CABLES,
    CATEGORY_PNEUMATIC_HOSES,
    CATEGORY_CABLES_FOR_MOTION,
    CATEGORY_SLEWING_RINGS_AND_SLEWING_RING_BEARINGS,
    CATEGORY_GEARS_GEAR_RACKS,
    CATEGORY_BALL_BEARINGS,
    CATEGORY_DRYGEAR_GEAR_TECHNOLOGY,
    CATEGORY_IGUBAL_SELF_ALIGNING_BEARINGS,
    CATEGORY_DRYLIN_T_RAIL_GUIDE,
    CATEGORY_DRYLIN_R_SHAFT_GUIDES,
    CATEGORY_DRYLIN_R_SHAFT_GUIDES,
    CATEGORY_DRYLIN_Q_LINEAR_SQUARE_GUIDES,
    CATEGORY_COATINGS
  ].includes(ck))) {
    return true;
  }
  if (categoryKeys.includes(CATEGORY_DRYLIN_LINEAR_TECHNOLOGY)) {
    return !!featureFlags.get("showDrylinLinearTechnology");
  }
  if (categoryKeys.includes(CATEGORY_BAR_STOCKS)) {
    return !!featureFlags.get("showBarStocks");
  }
  if (categoryKeys.includes(CATEGORY_CONNECTORS)) {
    return !!featureFlags.get("showConnectors");
  }
  if (categoryKeys.includes(CATEGORY_PMA)) {
    return !!featureFlags.get("showPMAShop");
  }
  return defaultValue;
}, "isCategoryEnabled");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CATEGORY_3D_MOVEMENT,
  CATEGORY_3D_PRINTING,
  CATEGORY_BALL_BEARINGS,
  CATEGORY_BAR_STOCKS,
  CATEGORY_CABLES_FOR_MOTION,
  CATEGORY_CF,
  CATEGORY_COATINGS,
  CATEGORY_CONNECTING_CABLES,
  CATEGORY_CONNECTORS,
  CATEGORY_DRIVE_TECHNOLOGY_FOR_LINEAR_MOVEMENTS,
  CATEGORY_DRYGEAR_GEAR_TECHNOLOGY,
  CATEGORY_DRYLIN_LEAD_SCREW_TECHNOLOGY,
  CATEGORY_DRYLIN_LINEAR_TECHNOLOGY,
  CATEGORY_DRYLIN_Q_LINEAR_SQUARE_GUIDES,
  CATEGORY_DRYLIN_R_SHAFT_GUIDES,
  CATEGORY_DRYLIN_T_RAIL_GUIDE,
  CATEGORY_E_CHAIN,
  CATEGORY_E_CHAIN_HORIZONTAL_SHELVES,
  CATEGORY_E_CHAIN_INTERIOR_SEPARATORS,
  CATEGORY_E_CHAIN_LINEAR_MOVEMENT,
  CATEGORY_E_CHAIN_MOUNTING_BRACKETS,
  CATEGORY_E_CHAIN_SMART_IOT_SOLUTIONS,
  CATEGORY_E_CHAIN_STRAIN_RELIEFS,
  CATEGORY_GEARS_GEAR_RACKS,
  CATEGORY_HARNESSED_CABLES,
  CATEGORY_IGUBAL_SELF_ALIGNING_BEARINGS,
  CATEGORY_LINER,
  CATEGORY_LOW_COST_AUTOMATION,
  CATEGORY_MOTORS,
  CATEGORY_MOTOR_FLANGES,
  CATEGORY_PMA,
  CATEGORY_PNEUMATIC_HOSES,
  CATEGORY_ROLLERS,
  CATEGORY_SLEWING_RINGS_AND_SLEWING_RING_BEARINGS,
  isCategoryEnabled
});
